'use client';

import { LicenseInfo } from '@mui/x-license-pro';

LicenseInfo.setLicenseKey('3f72966a7ad442b521cd43c49c6b8ca0Tz0xMjE0ODEsRT0xNzk0MDA5NTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');

export default function MuiLicense() {
  return null;
}